// extracted by mini-css-extract-plugin
export default {"paidFeatureAlert":"InfoAlert_paidFeatureAlert__mOo0m","heading":"InfoAlert_heading__slFd5","description":"InfoAlert_description__HPddf","firstCTA":"InfoAlert_firstCTA__iW+p-"};